import { Injectable, inject } from '@angular/core';
import { Customer } from '@entity/customer';
import { TreeNode } from 'primeng/api';
import { CustomerCase } from '@entity/customer-case';
import { CustomerCaseMutation } from '@entity/customer-case-mutation';
import { CustomerService } from '@service/customer.service';
import { AnyValue } from '@shared/table/table.types';
import { TreeTableCrudService } from '@shared/table/tree-table-crud.service';

@Injectable()
export class CustomersTreeTableService extends TreeTableCrudService<Customer> {
  protected readonly entityService = inject(CustomerService);

  protected toTreeNode(customer: Customer): TreeNode {
    return {
      data: {
        ...customer,
        customerCases: null,
      },
      children: customer.customerCases.map((customerCase: CustomerCase) => ({
        data: {
          ...customerCase,
          customerCaseMutations: null,
        },
        children: customerCase.customerCaseMutations.map((customerCaseMutation) => ({
          data: customerCaseMutation,
        })),
      })),
    };
  }

  protected toEntity(treeNode: TreeNode): Customer {
    return {
      ...treeNode.data,
      customerCases: treeNode.children?.map(
        (customerCase: AnyValue) =>
          ({
            ...customerCase.data,
            customerCaseMutations: customerCase.children?.map(
              (customerCaseMutation: AnyValue) =>
                ({
                  ...customerCaseMutation.data,
                }) as CustomerCaseMutation
            ),
          }) as CustomerCase
      ),
    } as Customer;
  }

  protected getId(customer: Customer): string {
    return customer.customerId;
  }

  createEntry(tree: TreeNode[], parent?: TreeNode | null): TreeNode {
    if (!parent) {
      return {
        data: {
          customerId: this.getNextId(tree, 'customerId'),
        },
        expanded: true,
        children: [
          {
            data: {
              caseId: 1,
            },
          },
        ],
      };
    } else if (parent.data.customerId) {
      return {
        data: {
          caseId: this.getNextId(parent.children ?? [], 'caseId'),
        },
        children: [],
      };
    } else {
      return {
        data: {},
      };
    }
  }
}
